import React from 'react';
import { ClientPortalLayout } from './ClientPortalLayout';
import { CalendarIcon, MapPinIcon, UsersIcon, CheckCircle2Icon, ClockIcon } from 'lucide-react';
export function OffsiteOverviewPage() {
  return <ClientPortalLayout data-id="element-468">
      <div className="p-6 lg:p-8 max-w-6xl mx-auto space-y-6" data-id="element-469">
        {/* Hero Card */}
        <div className="bg-white rounded-2xl border border-slate-200 p-8 relative overflow-hidden shadow-sm" data-id="element-470">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-100/50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-471" />

          <div className="relative z-10" data-id="element-472">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-600 text-xs font-semibold rounded-full mb-4" data-id="element-473">
              Leadership Strategy Offsite
            </span>
            <h1 className="font-serif-display text-4xl text-slate-900 mb-8" data-id="element-474">
              Helix Therapeutics Leadership Summit
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6 border-t border-slate-100" data-id="element-475">
              <div className="flex items-start gap-3" data-id="element-476">
                <CalendarIcon className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-477" />
                <div data-id="element-478">
                  <div className="text-sm font-bold text-slate-900" data-id="element-479">Dates</div>
                  <div className="text-sm text-slate-500" data-id="element-480">
                    Oct 22 - 25, 2026
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-481">
                <MapPinIcon className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-482" />
                <div data-id="element-483">
                  <div className="text-sm font-bold text-slate-900" data-id="element-484">
                    Location
                  </div>
                  <div className="text-sm text-slate-500" data-id="element-485">
                    L'Auberge de Sedona, Arizona
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-486">
                <UsersIcon className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-487" />
                <div data-id="element-488">
                  <div className="text-sm font-bold text-slate-900" data-id="element-489">
                    Participants
                  </div>
                  <div className="text-sm text-slate-500" data-id="element-490">
                    32 Senior Leaders
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 2-Col Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-491">
          {/* Key Objectives */}
          <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-200 p-8 shadow-sm" data-id="element-492">
            <div className="flex items-center gap-2 mb-6" data-id="element-493">
              <div className="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center" data-id="element-494">
                <div className="w-3 h-3 rounded-full border-2 border-amber-500" data-id="element-495" />
              </div>
              <h2 className="font-serif-display text-2xl text-slate-900" data-id="element-496">
                Key Objectives
              </h2>
            </div>

            <div className="space-y-6" data-id="element-497">
              {['Align leadership on the Q1-Q4 clinical trial pipeline and resource allocation.', 'Identify operational bottlenecks in current R&D workflows and design agile solutions.', 'Foster cross-functional collaboration between the scientific and commercial teams.'].map((obj, i) => <div key={i} className="flex gap-4" data-id="element-498">
                  <div className="w-6 h-6 rounded-full bg-slate-100 text-slate-500 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-499">
                    {i + 1}
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed" data-id="element-500">
                    {obj}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Preparation Status */}
          <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm" data-id="element-501">
            <h2 className="font-serif-display text-2xl text-slate-900 mb-6" data-id="element-502">
              Preparation Status
            </h2>

            <div className="mb-8" data-id="element-503">
              <div className="flex justify-between items-end mb-2" data-id="element-504">
                <div className="text-sm font-bold text-slate-900" data-id="element-505">
                  Diagnostic Completion
                </div>
                <div className="text-sm font-bold text-slate-900" data-id="element-506">78%</div>
              </div>
              <div className="h-2 bg-slate-100 rounded-full overflow-hidden mb-2" data-id="element-507">
                <div className="h-full bg-emerald-500 rounded-full" style={{
                width: '78%'
              }} data-id="element-508" />
              </div>
              <div className="text-xs text-slate-500" data-id="element-509">
                25 of 32 participants completed
              </div>
            </div>

            <div className="space-y-4 pt-6 border-t border-slate-100" data-id="element-510">
              {[{
              label: 'Contract Signed',
              status: 'done'
            }, {
              label: 'Dates Confirmed',
              status: 'done'
            }, {
              label: 'Diagnostic Launched',
              status: 'done'
            }, {
              label: 'Offsite Brief Generation',
              status: 'pending'
            }].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-511">
                  {item.status === 'done' ? <CheckCircle2Icon className="w-4 h-4 text-emerald-500 shrink-0" data-id="element-512" /> : <ClockIcon className="w-4 h-4 text-slate-300 shrink-0" data-id="element-513" />}
                  <span className={`text-sm ${item.status === 'done' ? 'text-slate-700' : 'text-slate-400'}`} data-id="element-514">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </ClientPortalLayout>;
}